import React from 'react'

export default function () {
  return (
    <div><i class="fa fa-spinner fa-spin fa-8x" aria-hidden="true"></i></div>
  )
}
